import { useEffect } from 'react';
import history from '../../../../../core/history';
import { getQueryParams } from '../../../../../core/util/url';

export default (loading: any, pastAppointments: any, userProfileId: any, setTabIndex: any) => {
  useEffect(() => {
    const searchParams = getQueryParams(window.location.href);
    if (!loading && searchParams.b) {
      // check that we don't need to change tabs
      // if it's not found, we're just blindly assuming that it's on the upcoming tab
      const isInPast = pastAppointments.findIndex((apt: any) => apt.id === searchParams.b) > -1;
      if (isInPast) setTabIndex(1);

      history.replace(`/account/home/${userProfileId}/manage#${searchParams.b}`);
    }
  }, [loading, pastAppointments, userProfileId, setTabIndex]);
};
